/**
 * BaseFretebasEmpresaCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {BaseFretebasEmpresa} from '@/model/resource/BaseFretebasEmpresa'

/* TODO: review generated class */
@HttpExclude()
export class BaseFretebasEmpresaCollection extends PageCollection<
  BaseFretebasEmpresa
> {
  constructor() {
    super(BaseFretebasEmpresa)
  }

  queryAsPage() {
    return this.listBaseFretebasEmpresa()
  }

  async listBaseFretebasEmpresa() {
    return await Request.get(`/admin/base-fretebas-empresa`, {
      params: this.params,
    })
      .name('listBaseFretebasEmpresa')
      .as(this)
      .getResponse()
  }

  async listCsvBaseFretebasEmpresa() {
    return await Request.get(`/admin/base-fretebas-empresa/csv`, {
      params: this.params,
    })
      .name('listCsvBaseFretebasEmpresa')
      .as(this)
      .getResponse()
  }
}
